import {DiagramType} from '@dv5/domain'

export interface DiagramExample {
    name: string
    diagramType: DiagramType
    sourceCode: string
}

export const diagramExamples: DiagramExample[] = [
    // PlantUML
    {
        name: 'Class Diagram',
        diagramType: DiagramType.PLANTUML,
        sourceCode: '@startuml\nclass Foo {\n  +void bar()\n}\nclass Baz {\n  +void qux()\n}\nFoo <|-- Baz\n@enduml',
    },
    {
        name: 'Sequence Diagram',
        diagramType: DiagramType.PLANTUML,
        sourceCode: '@startuml\nAlice -> Bob: Authentication Request\nBob --> Alice: Authentication Response\nAlice -> Bob: Another request\nAlice <-- Bob: Another response\n@enduml',
    },
    {
        name: 'Use Case',
        diagramType: DiagramType.PLANTUML,
        sourceCode: '@startuml\nleft to right direction\nactor User\nrectangle System {\n  User --> (Login)\n  User --> (View Dashboard)\n  (Login) .> (Authenticate) : extends\n}\n@enduml',
    },
    {
        name: 'Activity',
        diagramType: DiagramType.PLANTUML,
        sourceCode: '@startuml\nstart\n:Receive request;\nif (Valid?) then (yes)\n  :Process;\nelse (no)\n  :Reject;\nendif\nstop\n@enduml',
    },
    // Mermaid
    {
        name: 'Flowchart',
        diagramType: DiagramType.MERMAID,
        sourceCode: 'graph TD\n    A[Start] --> B{Decision}\n    B -->|Yes| C[Process]\n    B -->|No| D[End]',
    },
    {
        name: 'Sequence',
        diagramType: DiagramType.MERMAID,
        sourceCode: 'sequenceDiagram\n    participant A as Alice\n    participant B as Bob\n    A->>B: Hello Bob\n    B-->>A: Hi Alice\n    A->>B: How are you?\n    B-->>A: Fine thanks',
    },
    {
        name: 'Gantt',
        diagramType: DiagramType.MERMAID,
        sourceCode: 'gantt\n    title Project Plan\n    dateFormat  YYYY-MM-DD\n    section Design\n    Architecture  :a1, 2024-01-01, 7d\n    Implementation :after a1, 14d',
    },
    // D2
    {
        name: 'Network',
        diagramType: DiagramType.D2,
        sourceCode: 'user -> load balancer: request\nload balancer -> server1: route\nload balancer -> server2: route\nserver1 -> database: query\nserver2 -> database: query',
    },
    {
        name: 'Flow',
        diagramType: DiagramType.D2,
        sourceCode: 'start -> parse input\nparse input -> validate\nvalidate -> process -> output\nvalidate -> reject -> output\nprocess -> output',
    },
]
